import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import RadioGroup from '@react/react-spectrum/RadioGroup'
import Radio from '@react/react-spectrum/Radio'
import Textfield from '@react/react-spectrum/Textfield'
import Switch from '@react/react-spectrum/Switch'
import { FormEditorInput } from 'components/FormEditor'
import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const Form = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Heading'>
        <Textfield
          placeholder='Heading'
          name='name'
          value={content.name || ''}
          onChange={onChange('name')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Description'>
        <Textfield
          placeholder='Description'
          name='description'
          value={content.description || ''}
          onChange={onChange('description')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Banner' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`form-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <Switch
        label='Show&nbsp;Call&nbsp;Center&nbsp;Link'
        checked={!!content.showCallCenter}
        onChange={(v) => !disabled && onChange('showCallCenter')(v)}
      />

      <FieldLabel label='Call Center link'>
        <Textfield
          placeholder='Call Center Link'
          name='callCenterLink'
          value={content.callCenterLink || ''}
          onChange={onChange('callCenterLink')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Submit form data to:'>
        <RadioGroup defaultSelectedValue={content?.submitType || 'aep'} onChange={onChange('submitType')}>
          <Radio label='AEP' value='aep' />
          <Radio label='Webhook' value='webhook' />
        </RadioGroup>
      </FieldLabel>

      {content.submitType === 'aep' && (
        <FieldLabel label='Event Type'>
          <Textfield
            placeholder='checkout'
            name='eventType'
            value={content.eventType || ''}
            onChange={onChange('eventType')}
            disabled={disabled}
          />
        </FieldLabel>
      )}

      {content.submitType === 'webhook' && (
        <FieldLabel label='URL' name='url'>
          <Textfield value={content.url || ''} onChange={onChange('url')} />
        </FieldLabel>
      )}

      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='buttonLabel'
          value={content.buttonLabel || ''}
          onChange={onChange('buttonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='On submit redirect to'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.buttonTarget || ''}
          onChange={onChange('buttonTarget')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Submit Message'>
        <RichTextFormField
          label='Submit Message'
          value={content.submitMessage || ''}
          onChange={onChange('submitMessage')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Form Fields'>
        <FormEditorInput
          label='Form Fields'
          fields={content.fields}
          onChange={onChange('fields')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Form', content: Form }]
